import React, { FC } from "react";
import styled from "styled-components";
import { ThemeProps } from "../styles/theme";

export type TrainingMode = "sequential" | "random";

const List = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 8px;
`;

const ModeButton = styled.button<ThemeProps>`
    text-align: left;
    padding: 16px 18px;
    background-color: ${p => p.theme.secondaryBackground};
    border: ${p => p.theme.primaryBorder} 1px solid;
    border-radius: 8px;
    cursor: pointer;

    &:hover {
        border-color: ${p => p.theme.accentColor};
    }
`;

const ModeName = styled.div<ThemeProps>`
    font-size: 15px;
    font-weight: 600;
    color: ${p => p.theme.primaryText};
    margin-bottom: 4px;
`;

const ModeDescription = styled.div<ThemeProps>`
    font-size: 13px;
    color: ${p => p.theme.secondaryText};
`;

interface ModeSelectProps {
    onSelect: (mode: TrainingMode) => void;
}

export const ModeSelect: FC<ModeSelectProps> = ({ onSelect }) => (
    <List>
        <ModeButton type="button" onClick={() => onSelect("sequential")}>
            <ModeName>Sequential</ModeName>
            <ModeDescription>
                Go table by table, row by row. Rows build up in place inside each table.
            </ModeDescription>
        </ModeButton>
        <ModeButton type="button" onClick={() => onSelect("random")}>
            <ModeName>Random</ModeName>
            <ModeDescription>
                One shuffled pass over every row of every table, one at a time.
            </ModeDescription>
        </ModeButton>
    </List>
);
